<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="col-12 mb-4 banner-wrapper" v-if="this.banner_desktop">
                    <img v-if="this.banner_desktop != ''" class="desktop" v-bind:src="this.banner_desktop" v-bind:alt="this.page_title"  v-bind:title="this.page_title" />
                    <img v-if="this.banner_mobile != ''" class="mobile" v-bind:src="this.banner_mobile" v-bind:alt="this.page_title"  v-bind:title="this.page_title" />
                </div>
                <div class="col-12 mt-4 mb-4 featured-products-wrapper" v-if="Object.keys(this.selected_products).length != 0">
                    <h3>Here are some of the e-voucher brands you can choose from.</h3>

                    <ul class="products">
                      <template v-for="item in selected_products">
                        <li>
                            <a target="_blank" v-bind:href="item.link">

                                <img class="desktop" v-bind:src="item.filename" v-bind:alt="item.title"  v-bind:title="item.title" />
                            </a>
                            <h4><a target="_blank" v-bind:href="item.link">{{ item.title }}</a></h4>
                            <p>{{ item.caption }}</p>
                        </li>
                      </template>
                    </ul>
                </div>

                <div class="col-12 mt-4 mb-4 redeem-voucher">
                    <div class="card">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-md-6">
                                    <img class="img-fluid" v-bind:src="'/img/logo-white.png'"  width="150" alt="Gifted PH" title="Gifted PH" />
                                </div>
                                <div class="col-md-6">
                                    <h1 class="title">Gift Card Plus</h1>
                                </div>

                            </div>
                        </div>
                        <div class="card card-title">
                            <h3>Claim Your Gift</h3>

                        </div>
                        <div class="card-body">
                            <form id="redeem" action="#claim" enctype="multipart/form-data" method="POST">
                                <table width="100%" class="table">
                                    <tbody>
                                        
                                        <input type="hidden" name="_token" v-bind:value="csrf">
                                        <tr v-if="wallet_exist == 0">
                                            <td style="vertical-align: middle;"><strong>Email:</strong></td>
                                            <td>
                                                <input class="form-control" type="email" name="company_email" id="company_email" value="" placeholder="Your Registered Email" required="" v-bind:value="company_email" />
                                            </td>
                                        </tr>

                                        <tr v-if="wallet_pin == 1 && wallet_exist == 0">
                                            <td style="vertical-align: middle;"><strong>PIN:</strong></td>
                                            <td>
                                                <input class="form-control" type="password" name="wallet_pin" id="wallet_pin" value="" placeholder="Your Wallet PIN" required="" value="" />
                                            </td>
                                        </tr>

                                        <tr v-if="wallet_exist == 0">
                                            <td colspan="2">
                                                <button class="btn btn-redeem"> Verify</button>
                                            </td>
                                        </tr>
                                        <tr v-if="not_valid == 1">
                                            <td colspan="2">
                                                <div class="alert alert-warning text-center" role="alert" style="margin: 0;">
                                                    {{ this.not_valid_msg }}
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </form>

                                <table id="claim" width="100%" class="table" v-if="wallet_exist == 1">          
                                    <tbody>
                                        <tr>
                                            <td class="hidden-sm-down" style="vertical-align: top;"><strong>Email:</strong></td>
                                            <td style="vertical-align: top;">
                                                <label class="hidden-md-up">Email:</label>
                                                <b>{{ this.company_email }}</b>
                                                <p style="margin: 0;"><a href="javascript:;" @click="changeEmail()">Reset</a></p>
                                                <input type="hidden" name="recipient_email" id="recipient_email" v-bind:value="company_email" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="hidden-sm-down" style="vertical-align: middle;"><strong>Wallet Balance:</strong></td>
                                            <td>
                                                <label class="hidden-md-up">Wallet Balance:</label>
                                                <div class="btn-wrapper">
                                                    <a class="btn btn-primary" @click="checkBalance()" href="javascript:;">Show Balance</a>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="hidden-sm-down" style="vertical-align: middle;"><strong>Product:</strong></td>
                                            <td>
                                                <label class="hidden-md-up">Product:</label>
                                                <select @change="productSelect" style="width: 100%; max-width: 240px; margin: 0;" name="product_id" id="product_id" class="form-control" required="">
                                                    <option value="" selected="selected">-- Select --</option>

                                                    <option v-for="product in product_options" :key="product.product_id" :value="product.product_id" :data-denominations="product.product_denominations">{{ product.product_name }}</option>

                                                </select>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="hidden-sm-down" style="vertical-align: middle;"><strong>Denomination:</strong></td>
                                            <td>
                                                <label class="hidden-md-up">Denomination:</label>
                                                <select style="width: 100%; max-width: 240px; margin: 0;" name="product_denomination" id="product_denomination" class="form-control" required="">
                                                    <option value="" selected="selected">-- No Product Selected  --</option>
                                                    
                                                </select>
                                            </td>
                                        </tr>
                                        

                                        <tr v-if="wallet_balance > 0">
                                            <td colspan="2">
                                                <button id="redeemBtn" class="btn btn-redeem" @click="redeem(corporate_id)"> <i class="fa fa-gift"></i> Claim</button>
                                            </td>
                                        </tr>

                                    </tbody>
                                </table>

                                <div v-if="wallet_exist == 1">
                                    <div class="btn-wrapper " style="text-align: center;">
                                        <a class="btn btn-primary btn-history" @click="showHistory()" href="javascript:;">Show Redemption History</a>
                                    </div>

                                    <table id="ggc-plus-container" width="100%" class="table">          
                                        <tbody>
                                            <tr>
                                                <td colspan="3"><h4 style="text-align: center; margin-top: 15px;">Your Recent Redemption below</h4></td>
                                            </tr>
                                            <tr>
                                                <td style="width: 40%;"><b>Order #</b></td>
                                                <td style="width: 40%;"><b>Product</b></td>
                                                <td style="width: 20%;"></td>
                                            </tr>

                                            <template v-for="order in my_orders">
                                            <tr>
                                                <td>
                                                    <p style="margin: 0;"><b>{{ order.order_number }}</b></p>
                                                    <p style="margin: 0;"><i>{{ order.ordered_on }}</i></p>
                                                </td>
                                                <td>{{ order.product_name }}</td>
                                                <td>
                                                    <a  v-if="order.voucher_id > 0" href="javascript:;" @click="resend(order.id)" class="btn btn-danger btn-sm">Resend</a>
                                                    <span v-if="order.voucher_id <= 0">No Voucher Yet</span>
                                                </td>
                                            </tr>
                                            </template>

                                        </tbody>
                                    </table>
                                </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 mt-4 mb-4 terms-wrapper" v-if="this.terms">
                    <h3>TERMS & CONDITIONS</h3>
                    <div class="terms" v-html="this.terms"></div>
                </div>

            </div>
        </div>
    </div>
</template>
<style>
    .swal2-title{
        display: block !important;
    }
    .swal2-select{
        margin: 0 auto;
        width: 100%;
        max-width: 265px;
        border-radius: 5px;
        -moz-appearance:none; /* Firefox */
        -webkit-appearance:none; /* Safari and Chrome */
        appearance:none;
        background: url('/img/dropdown-arrow.png') no-repeat right center;
        background-size: contain;
    }
    .swal2-select:focus{
        border: 1px solid #DE3C4C;
        outline: none;
    }
    .swal2-validation-message{
        background-color: transparent;
    }
    .hidden-sm-down{
        display: block;
    }
    .hidden-md-up{
        display: none;
    }
    .swal2-footer{
        margin: 0;
        border-top: 0;
    }
    #resendOTP{
        background-color: rgb(222, 60, 76);
        border-color: rgb(222, 60, 76);
    }

    @media only screen and (max-width: 767px) {
        .hidden-md-up{
            display: block;
        }
        .hidden-sm-down{
            display: none;
        }
        .swal2-title{
            font-size: 15px;
            line-height: 17px;
        }
    }
</style>
<style scoped>
    .redeem-voucher{
        max-width: 500px;
        margin: 0 auto;
    }
    .redeem-voucher .card-header{
        background-color: #DE3C4C;
    }
    .redeem-voucher .card-header .title{
        font-size: 30px;
        color: #fff;
        text-align: right;
        margin: 0 auto;
        padding: 8px 0;

    }
    .redeem-voucher .card-title{
        border: 0;
        margin: 0;
    }
    .redeem-voucher .card-title h3{
        text-align: center;
        padding: 15px;
        background-color: #eee;
        margin: 0;
    }
    .redeem-voucher table{
        margin: 0;
    }
    .redeem-voucher table tr:first-child td{
        border-top: 0;
    }
    .redeem-voucher button.btn-redeem{
        width: 100%;
        background-color: #DE3C4C;
        color: #fff;
        font-size: 20px;
        outline: 0;
        border: 0;
    }
    .redeem-voucher button.btn-redeem:hover, .redeem-voucher button.btn-redeem:focus{
        outline: 0;
        border: 0;
    }
    
    .banner-wrapper{
        width: 100%;
        clear: both;
        overflow: hidden;
    }
    .banner-wrapper img{
        width: 100%;
    }
    .banner-wrapper .desktop{
        display: block;
    }
    .banner-wrapper .mobile{
        display: none;
    }
    .featured-products-wrapper{
        width: 100%;
        clear: both;
        overflow: hidden;
    }
    .featured-products-wrapper h3{
        text-align: center;
        width: 100%;
        max-width: 700px;
        margin: 0 auto;
    }
    .featured-products-wrapper ul.products{
        list-style: none;
        margin: 0 auto;
        padding: 0;
    }
    .featured-products-wrapper ul.products li{
        width: 33.33%;
        display: inline-block;
        text-align: center;
        padding: 30px;
        vertical-align: top;
    }
    .featured-products-wrapper ul.products li a{
        display: block;
        color: #000;
    }
    .featured-products-wrapper ul.products li img{
        width: auto;
        height: 140px;
        margin-bottom: 15px;
    }
    .featured-products-wrapper ul.products li h4{

    }
    .featured-products-wrapper ul.products li p{

    }

    .terms-wrapper{
        width: 100%;
        clear: both;
        overflow: hidden;
    }
    .terms-wrapper h3{
        text-align: center;
        width: 100%;
    }
    .terms-wrapper .terms{
        width: 100%;
        max-width: 500px;
        margin: 0 auto;
    }

    
    #ggc-plus-container{
        display: none;
    }


@media (max-width: 999px) {
    .featured-products-wrapper ul.products li{
        width: 50%;
    }

}

@media (max-width: 767px) {
    .container{
        padding: 0;
    }
    .banner-wrapper{
        padding: 0;
    }
    .banner-wrapper .desktop{
        display: none;
    }
    .banner-wrapper .mobile{
        display: block;
    }
    .featured-products-wrapper{
        padding: 0;
    }
    .featured-products-wrapper ul.products li{
        width: 100%;
    }
    .terms-wrapper {
        width: auto;
    }
}
</style>
<script>

    export default {
        props: ['ggc', 'page', 'featured_products', 'orders'],
        data: () => ({
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            company_email: "",
            firstname: "",
            lastname: "",
            not_valid: "",
            not_valid_msg: "",
            wallet_exist: "",
            wallet_pin: "",
            wallet_transaction_count: "",
            wallet_cash_in: "",
            wallet_cash_out: "",
            wallet_balance: "",
            product_options: "",
            products_available: "",
            products_denominations: "",
            page_title: "",
            is_full_width: "",
            banner_desktop: "",
            banner_mobile: "",
            show_redemption: "",
            terms: "",
            pin_required: "",
            corporate_id: "",
            selected_products: "",
            slug: "",
            otp_expiration: "",
            my_orders: "",
        }), 
        mounted() {
    
            const ggc = JSON.parse(this.ggc)
            this.company_email = ggc.company_email;
            this.firstname = ggc.firstname;
            this.lastname = ggc.lastname;
            this.not_valid = ggc.not_valid;
            this.not_valid_msg = ggc.not_valid_msg;
            this.wallet_exist = ggc.wallet_exist;
            this.wallet_pin = ggc.wallet_pin;
            this.wallet_transaction_count = ggc.wallet_transaction_count;
            this.wallet_cash_in = ggc.wallet_cash_in;
            this.wallet_cash_out = ggc.wallet_cash_out;
            this.wallet_balance = ggc.wallet_balance;
            this.product_options = ggc.product_options;
            this.products_available = ggc.products_available;

            const page = JSON.parse(this.page)
            this.page_title = page.page_title;
            this.is_full_width = page.is_full_width;
            this.banner_desktop = page.banner_desktop;
            this.banner_mobile = page.banner_mobile;
            this.show_redemption = page.show_redemption;
            this.terms = page.terms;
            this.pin_required = page.pin_required;
            this.corporate_id = page.corporate_id;
            this.slug = page.page_slug;
            this.otp_expiration = page.otp_expiration;

            const my_products = JSON.parse(this.featured_products)
            this.selected_products = my_products;

            const orders = JSON.parse(this.orders)
            this.my_orders = orders;

        },
        methods: {
            redeem: function (corporateID) {
                //alert(corporateID);
                var productID = $('#product_id').val();
                var denomination = $('#product_denomination').val();
                var email = this.company_email;
                var otp_expiration = this.otp_expiration;

                if(denomination > 0 && productID > 0){

                    if(otp_expiration == 1){

                        return $.ajax({
                            type: "POST",
                            url: "/api/validate_otp_expiration",
                            data: { 'email': email, 'source': 'Landing Page Redemption ('+this.slug+')' },
                            cache: false,
                        })
                        .then(response => {
                            const is_validate_otp_expiration = JSON.parse(response);
                            if(is_validate_otp_expiration.response.class == "success"){

                                Swal.fire({
                                    title: 'Are you sure?',
                                    showCancelButton: true,
                                    confirmButtonText: 'Claim',
                                    confirmButtonColor: '#DE3C4C',
                                    showLoaderOnConfirm: true,
                                    background: '#fff',
                                    backdrop: 'rgb(198, 227, 222)',
                                    preConfirm: (isConfirm) => {

                                        if (!isConfirm) return;

                                        return $.ajax({
                                            type: "POST",
                                            url: "/api/ggc_plus_corporate",
                                            data: { 'email': email, 'productID': productID, 'denomination': denomination, 'corporateID': corporateID },
                                            cache: false,
                                        })
                                        .then(response => {
                                            console.log(response);
                                            return response
                                        })
                                        .catch(error => {
                                            Swal.showValidationMessage(
                                              `Request failed! Please contact support.`
                                            )
                                        })
                       
                                    },
                                    allowOutsideClick: () => !Swal.isLoading()
                                }).then((result) => {
                                    console.log(result);
                                    
                                    const new_result = JSON.parse(result.value);
                                    console.log(new_result);
                                    if (new_result) {
                                        Swal.fire({
                                          icon: new_result.response.class,
                                          title: new_result.response.message,
                                          confirmButtonColor: '#DE3C4C',
                                          confirmButtonText: 'Close'
                                        }).then((result) => {
                                            if (result.isConfirmed) {
                                                location.reload();
                                            }
                                        });
                                    }
                                }) 

                            }else{

                                /*
                                Swal.fire({
                                    //title: 'Verify Your Redemption',
                                    showCancelButton: true,
                                    confirmButtonText: 'Submit',
                                    confirmButtonColor: '#DE3C4C',
                                    showLoaderOnConfirm: true,
                                    background: '#fff',
                                    backdrop: 'rgb(198, 227, 222)',
                                    //input: 'text',
                                    html: '<h3>Verify Your Redemption</h3><p>Click on Send PIN to send a One Time PIN to your email address to confirm your redemption</p><div class="input-group mb-0">'+
                                          '<div class="input-group-prepend">'+
                                          '  <button id="resendOTP" data-email="'+email+'" data-source="Landing Page Redemption ('+this.slug+')" class="btn btn-secondary" type="button" style="width: 130px;"><span id="btn-text">Send PIN</span> <span id="timer"></span></button>'+
                                          '</div>'+
                                          '<input type="text" id="swal-input2-otp" class="form-control swal2-input" placeholder="Enter PIN" style="margin: 0;">'+
                                          '</div>'+
                                          '<p style="margin-top: 15px;">Click <a onclick="$(\'#resendOTP\').trigger(\'click\')" href="javascript:;">here</a> to resend the PIN to your email</p>'+
                                          '<div id="otp-message"></div>',
                                    footer: '<p style="text-align: center;">For any inquiries, please email us at admin@gifted.ph</p>',
                                    preConfirm: (isConfirm) => {

                                        if (!isConfirm) return;

                                        var otp = document.getElementById('swal-input2-otp').value;
                                        if (otp != '') {
                                            
                                            return $.ajax({
                                                type: "POST",
                                                url: "/api/validate_otp",
                                                data: { 'email': email, 'otp': otp },
                                                cache: false,
                                            })
                                            .then(response => {

                                                //console.log(response);
                                                const is_validate_otp = JSON.parse(response);
                                                if(is_validate_otp.response.class == "success"){

                                */
                                                    Swal.fire({
                                                        title: 'Are you sure?',
                                                        showCancelButton: true,
                                                        confirmButtonText: 'Claim',
                                                        confirmButtonColor: '#DE3C4C',
                                                        showLoaderOnConfirm: true,
                                                        background: '#fff',
                                                        backdrop: 'rgb(198, 227, 222)',
                                                        preConfirm: (isConfirm) => {

                                                            if (!isConfirm) return;
                        
                                                            return $.ajax({
                                                                type: "POST",
                                                                url: "/api/ggc_plus_corporate",
                                                                data: { 'email': email, 'productID': productID, 'denomination': denomination, 'corporateID': corporateID },
                                                                cache: false,
                                                            })
                                                            .then(response => {
                                                                console.log(response);
                                                                return response
                                                            })
                                                            .catch(error => {
                                                                Swal.showValidationMessage(
                                                                  `Request failed! Please contact support.`
                                                                )
                                                            })
                                           
                                                        },
                                                        allowOutsideClick: () => !Swal.isLoading()
                                                    }).then((result) => {
                                                        console.log(result);
                                                        
                                                        const new_result = JSON.parse(result.value);
                                                        console.log(new_result);
                                                        if (new_result) {
                                                            Swal.fire({
                                                              icon: new_result.response.class,
                                                              title: new_result.response.message,
                                                              confirmButtonColor: '#DE3C4C',
                                                              confirmButtonText: 'Close'
                                                            }).then((result) => {
                                                                if (result.isConfirmed) {
                                                                    location.reload();
                                                                }
                                                            });
                                                        }
                                                    }); 

                                /*

                                                }else{

                                                    Swal.showValidationMessage(
                                                          `OTP is invalid. Please check your email.`
                                                        );
                                                    $('#swal-input2-otp').focus();

                                                }
                                            })
                                            .catch(error => {
                                                Swal.showValidationMessage(
                                                  `Request failed! Please contact support.`
                                                )
                                            })
                           
                                        }else{
                                            Swal.showValidationMessage(
                                                  `OTP is required. Please check your email.`
                                                );
                                            $('#swal-input2-otp').focus();
                                        }

                                    },
                                    allowOutsideClick: () => !Swal.isLoading()
                                });
                                */

                            }
                        })
                        .catch(error => {
                            Swal.showValidationMessage(
                              `Request failed! Please contact support.`
                            )
                        });

                    }else{
                        /*
                        Swal.fire({
                            //title: 'Verify Your Redemption',
                            showCancelButton: true,
                            confirmButtonText: 'Submit',
                            confirmButtonColor: '#DE3C4C',
                            showLoaderOnConfirm: true,
                            background: '#fff',
                            backdrop: 'rgb(198, 227, 222)',
                            //input: 'text',
                            html: '<h3>Verify Your Redemption</h3><p>Click on Send PIN to send a One Time PIN to your email address to confirm your redemption</p><div class="input-group mb-0">'+
                                  '<div class="input-group-prepend">'+
                                  '  <button id="resendOTP" data-email="'+email+'" data-source="Landing Page Redemption ('+this.slug+')" class="btn btn-secondary" type="button" style="width: 130px;"><span id="btn-text">Send PIN</span> <span id="timer"></span></button>'+
                                  '</div>'+
                                  '<input type="text" id="swal-input2-otp" class="form-control swal2-input" placeholder="Enter PIN" style="margin: 0;">'+
                                  '</div>'+
                                  '<p style="margin-top: 15px;">Click <a onclick="$(\'#resendOTP\').trigger(\'click\')" href="javascript:;">here</a> to resend the PIN to your email</p>'+
                                  '<div id="otp-message"></div>',
                            footer: '<p style="text-align: center;">For any inquiries, please email us at admin@gifted.ph</p>',
                            preConfirm: (isConfirm) => {

                                if (!isConfirm) return;

                                var otp = document.getElementById('swal-input2-otp').value;
                                if (otp != '') {
                                    
                                    return $.ajax({
                                        type: "POST",
                                        url: "/api/validate_otp",
                                        data: { 'email': email, 'otp': otp },
                                        cache: false,
                                    })
                                    .then(response => {

                                        //console.log(response);
                                        const is_validate_otp = JSON.parse(response);
                                        if(is_validate_otp.response.class == "success"){

                        */

                                            Swal.fire({
                                                title: 'Are you sure?',
                                                showCancelButton: true,
                                                confirmButtonText: 'Claim',
                                                confirmButtonColor: '#DE3C4C',
                                                showLoaderOnConfirm: true,
                                                background: '#fff',
                                                backdrop: 'rgb(198, 227, 222)',
                                                preConfirm: (isConfirm) => {

                                                    if (!isConfirm) return;

                                                    return $.ajax({
                                                        type: "POST",
                                                        url: "/api/ggc_plus_corporate",
                                                        data: { 'email': email, 'productID': productID, 'denomination': denomination, 'corporateID': corporateID },
                                                        cache: false,
                                                    })
                                                    .then(response => {
                                                        console.log(response);
                                                        return response
                                                    })
                                                    .catch(error => {
                                                        Swal.showValidationMessage(
                                                          `Request failed! Please contact support.`
                                                        )
                                                    })
                                   
                                                },
                                                allowOutsideClick: () => !Swal.isLoading()
                                            }).then((result) => {
                                                console.log(result);
                                                
                                                const new_result = JSON.parse(result.value);
                                                console.log(new_result);
                                                if (new_result) {
                                                    Swal.fire({
                                                      icon: new_result.response.class,
                                                      title: new_result.response.message,
                                                      confirmButtonColor: '#DE3C4C',
                                                      confirmButtonText: 'Close'
                                                    }).then((result) => {
                                                        if (result.isConfirmed) {
                                                            location.reload();
                                                        }
                                                    });
                                                }
                                            });
                        /*
                                        }else{

                                            Swal.showValidationMessage(
                                                  `OTP is invalid. Please check your email.`
                                                );
                                            $('#swal-input2-otp').focus();

                                        }
                                    })
                                    .catch(error => {
                                        Swal.showValidationMessage(
                                          `Request failed! Please contact support.`
                                        )
                                    })
                   
                                }else{
                                    Swal.showValidationMessage(
                                          `OTP is required. Please check your email.`
                                        );
                                    $('#swal-input2-otp').focus();
                                }

                            },
                            allowOutsideClick: () => !Swal.isLoading()
                        });
                        */
                    }
                }else{
                    Swal.fire({
                      icon: 'error',
                      title: 'No Product Selected or Invalid Denomination',
                      showConfirmButton: false,
                      timer: 2000
                    })
                }
            },
            resend: function (order_id) {
                //alert(order_id);

                Swal.fire({
                    title: 'Resend this Voucher?',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    confirmButtonColor: '#DE3C4C',
                    showLoaderOnConfirm: true,
                    background: '#fff',
                    backdrop: 'rgb(198, 227, 222)',
                    preConfirm: (isConfirm) => {

                        if (!isConfirm) return;

                        return $.ajax({
                            type: "GET",
                            url: "/api/sendVoucher/"+order_id,
                            //data: { 'id': order_id },
                            cache: false,
                        })
                        .then(response => {
                            console.log(response);
                            //return response

                            if (response == 1) {
                                Swal.fire({
                                  icon:"success",
                                  title: "Your voucher successfully sent!",
                                  confirmButtonColor: '#DE3C4C',
                                  confirmButtonText: 'Close'
                                });
                            }else{
                                Swal.showValidationMessage(
                                  `Request failed! Please contact support.`
                                )
                            }

                        })
                        .catch(error => {
                            Swal.showValidationMessage(
                              `Request failed! Please contact support.`
                            )
                        })
       
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    console.log(result);
                    
                    if (result == 1) {
                        Swal.fire({
                          icon:"success",
                          title: "Your voucher successfully sent!",
                          confirmButtonColor: '#DE3C4C',
                          confirmButtonText: 'Close'
                        });
                    }else{
                        Swal.showValidationMessage(
                          `Request failed! Please contact support.`
                        )
                    }
                });

            },
            changeEmail: function () {

                /*
                Swal.fire({
                    title: 'Are you sure to change Email?',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    showLoaderOnConfirm: true,
                    background: '#fff',
                    backdrop: 'rgb(209 73 85 / .9)',
                    preConfirm: (isConfirm) => {
                        if (!isConfirm) return;

                        $('<input type="hidden" name="company_email" id="company_email" value="" />').appendTo('#frm_company_email');
                        $('#frm_company_email').submit();
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                })*/
                $('<input type="hidden" name="company_email" id="company_email" value="" />').appendTo('#redeem');
                $('#redeem').submit();
            },
            checkBalance: function () {
                //alert('Show balance')
                var email = this.company_email;
                var otp_expiration = this.otp_expiration;

                if(otp_expiration == 1){

                    return $.ajax({
                        type: "POST",
                        url: "/api/validate_otp_expiration",
                        data: { 'email': email, 'source': 'Landing Page Redemption ('+this.slug+')' },
                        cache: false,
                    })
                    .then(response => {
                        const is_validate_otp_expiration = JSON.parse(response);
                        if(is_validate_otp_expiration.response.class == "success"){

                            //Check balance
                            return $.ajax({
                                type: "GET",
                                url: "/api/wallet/balance/"+email,
                                //data: { 'id': order_id },
                                cache: false,
                            })
                            .then(response => {
                                
                                //return response
                                const wallet = JSON.parse(response);
                                console.log(wallet);

                                if (wallet.response.class == "success") {
                                    Swal.fire({
                                      icon:"success",
                                      title: "Your wallet balance is &#8369;"+ new Intl.NumberFormat('en-US').format(wallet.response.data),
                                      confirmButtonColor: '#DE3C4C',
                                      confirmButtonText: 'Close'
                                    });
                                }else{
                                    Swal.showValidationMessage(
                                      `Request failed! Please contact support.`
                                    )
                                }


                            })
                            .catch(error => {
                                Swal.showValidationMessage(
                                  `Request failed! Please contact support.`
                                )
                            });

                        }else{

                            
                            Swal.fire({
                                //title: 'Verify Your Redemption',
                                showCancelButton: true,
                                confirmButtonText: 'Submit',
                                confirmButtonColor: '#DE3C4C',
                                showLoaderOnConfirm: true,
                                background: '#fff',
                                backdrop: 'rgb(198, 227, 222)',
                                //input: 'text',
                                html: '<h3>Verify Your Redemption</h3><p>Click on Send PIN to send a One Time PIN to your email address to confirm your redemption</p><div class="input-group mb-0">'+
                                      '<div class="input-group-prepend">'+
                                      '  <button id="resendOTP" data-email="'+email+'" data-source="Landing Page Redemption ('+this.slug+')" class="btn btn-secondary" type="button" style="width: 130px;"><span id="btn-text">Send PIN</span> <span id="timer"></span></button>'+
                                      '</div>'+
                                      '<input type="text" id="swal-input2-otp" class="form-control swal2-input" placeholder="Enter PIN" style="margin: 0;">'+
                                      '</div>'+
                                      '<p style="margin-top: 15px;">Click <a onclick="$(\'#resendOTP\').trigger(\'click\')" href="javascript:;">here</a> to resend the PIN to your email</p>'+
                                      '<div id="otp-message"></div>',
                                footer: '<p style="text-align: center;">For any inquiries, please email us at admin@gifted.ph</p>',
                                preConfirm: (isConfirm) => {

                                    if (!isConfirm) return;

                                    var otp = document.getElementById('swal-input2-otp').value;
                                    if (otp != '') {
                                        
                                        return $.ajax({
                                            type: "POST",
                                            url: "/api/validate_otp",
                                            data: { 'email': email, 'otp': otp },
                                            cache: false,
                                        })
                                        .then(response => {

                                            //console.log(response);
                                            const is_validate_otp = JSON.parse(response);
                                            if(is_validate_otp.response.class == "success"){

                                                
                                                //Check balance
                                                return $.ajax({
                                                    type: "GET",
                                                    url: "/api/wallet/balance/"+email,
                                                    //data: { 'id': order_id },
                                                    cache: false,
                                                })
                                                .then(response => {
                                                    
                                                    //return response
                                                    const wallet = JSON.parse(response);
                                                    console.log(wallet);

                                                    if (wallet.response.class == "success") {
                                                        Swal.fire({
                                                          icon:"success",
                                                          title: "Your wallet balance is &#8369;"+ new Intl.NumberFormat('en-US').format(wallet.response.data),
                                                          confirmButtonColor: '#DE3C4C',
                                                          confirmButtonText: 'Close'
                                                        });
                                                    }else{
                                                        Swal.showValidationMessage(
                                                          `Request failed! Please contact support.`
                                                        )
                                                    }


                                                })
                                                .catch(error => {
                                                    Swal.showValidationMessage(
                                                      `Request failed! Please contact support.`
                                                    )
                                                });


                                            }else{

                                                Swal.showValidationMessage(
                                                      `OTP is invalid. Please check your email.`
                                                    );
                                                $('#swal-input2-otp').focus();

                                            }
                                        })
                                        .catch(error => {
                                            Swal.showValidationMessage(
                                              `Request failed! Please contact support.`
                                            )
                                        })
                       
                                    }else{
                                        Swal.showValidationMessage(
                                              `OTP is required. Please check your email.`
                                            );
                                        $('#swal-input2-otp').focus();
                                    }

                                },
                                allowOutsideClick: () => !Swal.isLoading()
                            });

                        }
                    })
                    .catch(error => {
                        Swal.showValidationMessage(
                          `Request failed! Please contact support.`
                        )
                    });

                }else{
                    
                    //Check balance
                    return $.ajax({
                        type: "GET",
                        url: "/api/wallet/balance/"+email,
                        //data: { 'id': order_id },
                        cache: false,
                    })
                    .then(response => {
                        console.log(response);
                        //return response

                        const wallet = JSON.parse(response);
                        //console.log(wallet);

                        if (wallet.response.class == "success") {
                            Swal.fire({
                              icon:"success",
                              title: "Your wallet balance is &#8369;"+ new Intl.NumberFormat('en-US').format(wallet.response.data),
                              confirmButtonColor: '#DE3C4C',
                              confirmButtonText: 'Close'
                            });
                        }else{
                            Swal.showValidationMessage(
                              `Request failed! Please contact support.`
                            )
                        }

                    })
                    .catch(error => {
                        Swal.showValidationMessage(
                          `Request failed! Please contact support.`
                        )
                    });

                }
            }, 
            showHistory: function () {
                //alert('Show History')

                var email = this.company_email;
                var otp_expiration = this.otp_expiration;

                if(otp_expiration == 1){

                    return $.ajax({
                        type: "POST",
                        url: "/api/validate_otp_expiration",
                        data: { 'email': email, 'source': 'Landing Page Redemption ('+this.slug+')' },
                        cache: false,
                    })
                    .then(response => {
                        const is_validate_otp_expiration = JSON.parse(response);
                        if(is_validate_otp_expiration.response.class == "error"){

                            Swal.fire({
                                //title: 'Verify Your Redemption',
                                showCancelButton: true,
                                confirmButtonText: 'Submit',
                                confirmButtonColor: '#DE3C4C',
                                showLoaderOnConfirm: true,
                                background: '#fff',
                                backdrop: 'rgb(198, 227, 222)',
                                //input: 'text',
                                html: '<h3>Verify Your Redemption</h3><p>Click on Send PIN to send a One Time PIN to your email address to confirm your redemption</p><div class="input-group mb-0">'+
                                      '<div class="input-group-prepend">'+
                                      '  <button id="resendOTP" data-email="'+email+'" data-source="Landing Page Redemption ('+this.slug+')" class="btn btn-secondary" type="button" style="width: 130px;"><span id="btn-text">Send PIN</span> <span id="timer"></span></button>'+
                                      '</div>'+
                                      '<input type="text" id="swal-input2-otp" class="form-control swal2-input" placeholder="Enter PIN" style="margin: 0;">'+
                                      '</div>'+
                                      '<p style="margin-top: 15px;">Click <a onclick="$(\'#resendOTP\').trigger(\'click\')" href="javascript:;">here</a> to resend the PIN to your email</p>'+
                                      '<div id="otp-message"></div>',
                                footer: '<p style="text-align: center;">For any inquiries, please email us at admin@gifted.ph</p>',
                                preConfirm: (isConfirm) => {

                                    if (!isConfirm) return;

                                    var otp = document.getElementById('swal-input2-otp').value;
                                    if (otp != '') {
                                        
                                        return $.ajax({
                                            type: "POST",
                                            url: "/api/validate_otp",
                                            data: { 'email': email, 'otp': otp },
                                            cache: false,
                                        })
                                        .then(response => {

                                            //console.log(response);
                                            const is_validate_otp = JSON.parse(response);
                                            if(is_validate_otp.response.class == "success"){

                                                //Show history
                                                $('#ggc-plus-container').slideDown();
                                                $('.btn-wrapper .btn.btn-history').hide();

                                            }else{

                                                Swal.showValidationMessage(
                                                      `OTP is invalid. Please check your email.`
                                                    );
                                                $('#swal-input2-otp').focus();

                                            }
                                        })
                                        .catch(error => {
                                            Swal.showValidationMessage(
                                              `Request failed! Please contact support.`
                                            )
                                        })
                       
                                    }else{
                                        Swal.showValidationMessage(
                                              `OTP is required. Please check your email.`
                                            );
                                        $('#swal-input2-otp').focus();
                                    }

                                },
                                allowOutsideClick: () => !Swal.isLoading()
                            });

                        }else{
                    
                            //Show history
                            $('#ggc-plus-container').slideDown();
                            $('.btn-wrapper .btn.btn-history').hide();

                        }
                    })
                    .catch(error => {
                        Swal.showValidationMessage(
                          `Request failed! Please contact support.`
                        )
                    });

                }else{
                    
                    //Show history
                    $('#ggc-plus-container').slideDown();
                    $('.btn-wrapper .btn.btn-history').hide();

                }
            },
            productSelect:function(e){
                if (e.target.options.selectedIndex > -1) {
                    const theTarget = e.target.options[e.target.options.selectedIndex].dataset;
                    this.products_denominations = theTarget.denominations;
                    this.products_denominations = this.products_denominations.split(',');

                    let options = '';
                    this.products_denominations.map((deno) =>{
                        if(deno){
                            options += `<option value="${deno}">${deno}</option>`;
                        }
                    });
                    $('#product_denomination').html(options);

                    console.log(this.products_denominations);
                }
            }
        }
    }


    let timerOn = true;

    function timer(remaining) {
        var m = Math.floor(remaining / 60);
        var s = remaining % 60;

        m = m < 10 ? '0' + m : m;
        s = s < 10 ? '0' + s : s;
        $("#timer").html(m + ':' + s);
        remaining -= 1;

        if(remaining >= 0 && timerOn) {
        setTimeout(function() {
            timer(remaining);
        }, 1000);
        return;
        }

        if(!timerOn) {
        // Do validate stuff here
        return;
        }

        // Do timeout stuff here
        //alert('Timeout for otp');
        $("#resendOTP").prop('disabled', false);
        $("#timer").html("");
    }

    
    $( "body" ).delegate( "#resendOTP", "click", function() {

        $(this).prop('disabled', true);
        var email = $(this).data( "email");
        var source = $(this).data( "source");
        //alert(email);
        timer(120);

        $('#btn-text').text('Resend');

        return $.ajax({
            type: "POST",
            url: "/api/resend_otp",
            data: { 'email': email, 'source': source, '_token': $('meta[name="csrf_token"]').attr('content') },
            cache: false,
        })
        .then(response => {
            console.log(response);
            //return response
            $('#otp-message').html("<p style='margin: 5px 0 0;' class='text-success'>Please check your email for OTP</p>");
            setTimeout(function () {
                   $('#otp-message').slideUp().html("");
                }, 5000);
            $('#swal-input2-otp').focus();
        })
        .catch(error => {
            Swal.showValidationMessage(
              `Request OTP failed! Please contact support.`
            )
        });

    });

</script>